import { TextArea as CssModulesTextarea, TextAreaProps } from '@sunwebgroup/uds-ui/fields/textarea-field'
import { styled } from 'styled-components'

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/fields/textarea-field' instead.
 */
const TextArea = Object.assign(
  styled(CssModulesTextarea)<TextAreaProps>``,
  { displayName: 'TextArea' },
)

export default TextArea
